module.exports = __webpack_public_path__ + "img/countedServiceTransactions.f29c9abe.svg";